import Vue from "vue";
import Vuex from "vuex";
import route from "./modules/route";
import user from "./modules/user";
import login from "./modules/login";
import dict from "./modules/dict";
import experimentTask from "./modules/experimentTask";
import personalization from "./modules/personalization";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    route,
    user,
    login,
    dict,
    experimentTask,
    personalization
    // 其他模块...
  },
});
